import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-normal" }
const _hoisted_2 = {
  key: 0,
  class: "mt-s3"
}

import Icon from '@/components/icon/Icon.vue';
import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notice',
  props: {
    text: null,
    icon: null,
    type: null,
    size: null,
    tooltip: null,
    iconColor: null
  },
  setup(__props: any) {

const props = __props as {
  text?: string;
  icon?: string;
  type?: string;
  size?: string;
  tooltip?: string;
  iconColor?: string;
}



const getClass = () => {
  return `text-${props.type ?? 'muted'} text-${props.size ?? 'sm'}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex align-items-start", getClass()])
    }, [
      (__props.icon)
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            name: __props.icon,
            size: "16",
            class: _normalizeClass(__props.iconColor ? `text-${__props.iconColor} mr-s2` : 'mr-s2')
          }, null, 8, ["name", "class"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "notice-text", {}, () => [
          _createTextVNode(_toDisplayString(__props.text), 1)
        ]),
        (__props.tooltip)
          ? (_openBlock(), _createBlock(TooltipIcon, {
              key: 0,
              tooltip: __props.tooltip,
              inline: ""
            }, null, 8, ["tooltip"]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (!!_ctx.$slots['default'])
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})